type TranslationKeys = {
  // Navigation
  home: string;
  movies: string;
  tvShows: string;
  genres: string;
  articles: string;
  calendar: string;
  pages: string;
  // Auth
  signIn: string;
  signUp: string;
  signOut: string;
  email: string;
  password: string;
  name: string;
  createAccount: string;
  alreadyHaveAccount: string;
  dontHaveAccount: string;
  // Movie Detail
  playTrailer: string;
  favorite: string;
  favorited: string;
  watchlist: string;
  inWatchlist: string;
  saved: string;
  like: string;
  liked: string;
  share: string;
  synopsis: string;
  synopsisNotAvailable: string;
  director: string;
  writers: string;
  language: string;
  budget: string;
  revenue: string;
  watchOn: string;
  backdropGallery: string;
  similarMovies: string;
  similar: string;
  recommendations: string;
  partOf: string;
  // TV Detail
  createdBy: string;
  episodeRuntime: string;
  type: string;
  episodes: string;
  // Season
  backToShow: string;
  seasonNotFound: string;
  episode: string;
  watch: string;
  // Calendar
  releaseCalendar: string;
  upcomingReleases: string;
  thisWeek: string;
  nextWeek: string;
  twoWeeks: string;
  threeWeeks: string;
  oneMonth: string;
  moviesCount: string;
  tvShowsCount: string;
  failedToLoad: string;
  backToHome: string;
  noReleasesThisWeek: string;
  today: string;
  // Streaming
  watchNow: string;
  // Search
  searchMoviesTvShows: string;
  searchResults: string;
  noResultsFound: string;
  // Generic
  movie: string;
  tv: string;
  loading: string;
  error: string;
  notFound: string;
  goHome: string;
  pleaseLogin: string;
  removedFromFavorites: string;
  addedToFavorites: string;
  removedFromWatchlist: string;
  addedToWatchlist: string;
  linkCopied: string;
  // Footer
  browse: string;
  account: string;
  legal: string;
  favorites: string;
  watchHistory: string;
  termsOfService: string;
  privacyPolicy: string;
  allRightsReserved: string;
  poweredBy: string;
  releaseCalendarFooter: string;
  // Admin
  settings: string;
  backToSite: string;
  dashboard: string;
  adsAndScripts: string;
  activityLogs: string;
  popularMovies: string;
  recentUsers: string;
  noDataAvailable: string;
  noUsersYet: string;
  newArticle: string;
  editArticle: string;
  category: string;
  status: string;
  published: string;
  draft: string;
  noArticlesYet: string;
  author: string;
  newPage: string;
  editPage: string;
  slug: string;
  metaDescription: string;
  noPagesYet: string;
  user: string;
  role: string;
  joined: string;
  noUsers: string;
  siteName: string;
  siteDescription: string;
  enableComments: string;
  enableRatings: string;
  saveSettings: string;
  saving: string;
  headerBanner: string;
  footerBanner: string;
  sidebarBanner: string;
  contentBanner: string;
  popunderLabel: string;
  adsteraAds: string;
  analyticsVerification: string;
  hiStatScript: string;
  googleSearchConsole: string;
  saveAllSettings: string;
  reset: string;
  actions: string;
  title: string;
  noLogsYet: string;
  details: string;
  ip: string;
  time: string;
  cancel: string;
  update: string;
  create: string;
  coverImageUrl: string;
  excerpt: string;
  contentHtml: string;
  date: string;
  deleted: string;
};

const translations: Record<string, TranslationKeys> = {
  'en-US': {
    home: 'Home', movies: 'Movies', tvShows: 'TV Shows', genres: 'Genres', articles: 'Articles', calendar: 'Calendar', pages: 'Pages',
    signIn: 'Sign In', signUp: 'Sign Up', signOut: 'Sign Out', email: 'Email', password: 'Password', name: 'Name',
    createAccount: 'Create Account', alreadyHaveAccount: 'Already have an account?', dontHaveAccount: "Don't have an account?",
    playTrailer: 'Play Trailer', favorite: 'Favorite', favorited: 'Favorited', watchlist: 'Watchlist', inWatchlist: 'In Watchlist',
    saved: 'Saved', like: 'Like', liked: 'Liked', share: 'Share', synopsis: 'Synopsis', synopsisNotAvailable: 'Synopsis not available.',
    director: 'Director', writers: 'Writers', language: 'Language', budget: 'Budget', revenue: 'Revenue',
    watchOn: 'Watch on', backdropGallery: 'Backdrop Gallery', similarMovies: 'Similar Movies', similar: 'Similar',
    recommendations: 'Recommendations', partOf: 'Part of',
    createdBy: 'Created By', episodeRuntime: 'Episode Runtime', type: 'Type', episodes: 'Episodes',
    backToShow: 'Back to Show', seasonNotFound: 'Season not found', episode: 'Episode', watch: 'Watch',
    releaseCalendar: 'Release Calendar', upcomingReleases: 'Upcoming movie & TV show releases',
    thisWeek: 'This Week', nextWeek: 'Next Week', twoWeeks: '2 Weeks', threeWeeks: '3 Weeks', oneMonth: '1 Month',
    moviesCount: 'Movies', tvShowsCount: 'TV Shows', failedToLoad: 'Failed to load release calendar', backToHome: 'Back to Home',
    noReleasesThisWeek: 'No releases this week', today: 'TODAY',
    watchNow: 'Watch Now',
    searchMoviesTvShows: 'Search movies, TV shows...', searchResults: 'Search Results', noResultsFound: 'No results found',
    movie: 'Movie', tv: 'TV', loading: 'Loading...', error: 'Error', notFound: 'Not Found', goHome: 'Go Home',
    pleaseLogin: 'Please login first', removedFromFavorites: 'Removed from favorites', addedToFavorites: 'Added to favorites',
    removedFromWatchlist: 'Removed from watchlist', addedToWatchlist: 'Added to watchlist', linkCopied: 'Link copied to clipboard',
    browse: 'Browse', account: 'Account', legal: 'Legal', favorites: 'Favorites', watchHistory: 'Watch History',
    termsOfService: 'Terms of Service', privacyPolicy: 'Privacy Policy', allRightsReserved: 'All rights reserved.',
    poweredBy: 'Powered by TMDB API', releaseCalendarFooter: 'Release Calendar',
    settings: 'Settings', backToSite: 'Back to Site', dashboard: 'Dashboard', adsAndScripts: 'Ads & Scripts', activityLogs: 'Activity Logs',
    popularMovies: 'Popular Movies', recentUsers: 'Recent Users', noDataAvailable: 'No data available', noUsersYet: 'No users yet',
    newArticle: 'New Article', editArticle: 'Edit Article', category: 'Category', status: 'Status',
    published: 'Published', draft: 'Draft', noArticlesYet: 'No articles yet', author: 'Author',
    newPage: 'New Page', editPage: 'Edit Page', slug: 'Slug', metaDescription: 'Meta Description', noPagesYet: 'No pages yet',
    user: 'User', role: 'Role', joined: 'Joined', noUsers: 'No users',
    siteName: 'Site Name', siteDescription: 'Site Description', enableComments: 'Enable Comments', enableRatings: 'Enable Ratings',
    saveSettings: 'Save Settings', saving: 'Saving...',
    headerBanner: 'Header Banner', footerBanner: 'Footer Banner', sidebarBanner: 'Sidebar Banner', contentBanner: 'Content Banner',
    popunderLabel: 'Popunder', adsteraAds: 'Adstera Ads', analyticsVerification: 'Analytics & Verification',
    hiStatScript: 'HiStat Script', googleSearchConsole: 'Google Search Console',
    saveAllSettings: 'Save All Settings', reset: 'Reset',
    actions: 'Actions', title: 'Title', noLogsYet: 'No logs yet', details: 'Details', ip: 'IP', time: 'Time',
    cancel: 'Cancel', update: 'Update', create: 'Create', coverImageUrl: 'Cover Image URL', excerpt: 'Excerpt', contentHtml: 'Content (HTML)',
    date: 'Date', deleted: 'Deleted',
  },
  'id-ID': {
    home: 'Beranda', movies: 'Film', tvShows: 'Serial TV', genres: 'Genre', articles: 'Artikel', calendar: 'Kalender', pages: 'Halaman',
    signIn: 'Masuk', signUp: 'Daftar', signOut: 'Keluar', email: 'Email', password: 'Kata Sandi', name: 'Nama',
    createAccount: 'Buat Akun', alreadyHaveAccount: 'Sudah punya akun?', dontHaveAccount: 'Belum punya akun?',
    playTrailer: 'Putar Trailer', favorite: 'Favorit', favorited: 'Difavoritkan', watchlist: 'Daftar Tonton', inWatchlist: 'Di Daftar Tonton',
    saved: 'Tersimpan', like: 'Suka', liked: 'Disukai', share: 'Bagikan', synopsis: 'Sinopsis', synopsisNotAvailable: 'Sinopsis tidak tersedia.',
    director: 'Sutradara', writers: 'Penulis', language: 'Bahasa', budget: 'Anggaran', revenue: 'Pendapatan',
    watchOn: 'Tonton di', backdropGallery: 'Galeri Backdrop', similarMovies: 'Film Serupa', similar: 'Serupa',
    recommendations: 'Rekomendasi', partOf: 'Bagian dari',
    createdBy: 'Dibuat Oleh', episodeRuntime: 'Durasi Episode', type: 'Tipe', episodes: 'Episode',
    backToShow: 'Kembali ke Serial', seasonNotFound: 'Season tidak ditemukan', episode: 'Episode', watch: 'Tonton',
    releaseCalendar: 'Kalender Rilis', upcomingReleases: 'Jadwal rilis film & serial TV',
    thisWeek: 'Minggu Ini', nextWeek: 'Minggu Depan', twoWeeks: '2 Minggu', threeWeeks: '3 Minggu', oneMonth: '1 Bulan',
    moviesCount: 'Film', tvShowsCount: 'Serial TV', failedToLoad: 'Gagal memuat kalender rilis', backToHome: 'Kembali ke Beranda',
    noReleasesThisWeek: 'Tidak ada rilis minggu ini', today: 'HARI INI',
    watchNow: 'Nonton Sekarang',
    searchMoviesTvShows: 'Cari film, serial TV...', searchResults: 'Hasil Pencarian', noResultsFound: 'Tidak ada hasil ditemukan',
    movie: 'Film', tv: 'TV', loading: 'Memuat...', error: 'Galat', notFound: 'Tidak Ditemukan', goHome: 'Ke Beranda',
    pleaseLogin: 'Silakan login terlebih dahulu', removedFromFavorites: 'Dihapus dari favorit', addedToFavorites: 'Ditambahkan ke favorit',
    removedFromWatchlist: 'Dihapus dari daftar tonton', addedToWatchlist: 'Ditambahkan ke daftar tonton', linkCopied: 'Link disalin ke clipboard',
    browse: 'Jelajahi', account: 'Akun', legal: 'Legal', favorites: 'Favorit', watchHistory: 'Riwayat Tontonan',
    termsOfService: 'Syarat Layanan', privacyPolicy: 'Kebijakan Privasi', allRightsReserved: 'Hak cipta dilindungi.',
    poweredBy: 'Didukung oleh TMDB API', releaseCalendarFooter: 'Kalender Rilis',
    settings: 'Pengaturan', backToSite: 'Kembali ke Situs', dashboard: 'Dasbor', adsAndScripts: 'Iklan & Skrip', activityLogs: 'Log Aktivitas',
    popularMovies: 'Film Populer', recentUsers: 'Pengguna Terbaru', noDataAvailable: 'Tidak ada data', noUsersYet: 'Belum ada pengguna',
    newArticle: 'Artikel Baru', editArticle: 'Edit Artikel', category: 'Kategori', status: 'Status',
    published: 'Diterbitkan', draft: 'Draf', noArticlesYet: 'Belum ada artikel', author: 'Penulis',
    newPage: 'Halaman Baru', editPage: 'Edit Halaman', slug: 'Slug', metaDescription: 'Deskripsi Meta', noPagesYet: 'Belum ada halaman',
    user: 'Pengguna', role: 'Peran', joined: 'Bergabung', noUsers: 'Belum ada pengguna',
    siteName: 'Nama Situs', siteDescription: 'Deskripsi Situs', enableComments: 'Aktifkan Komentar', enableRatings: 'Aktifkan Penilaian',
    saveSettings: 'Simpan Pengaturan', saving: 'Menyimpan...',
    headerBanner: 'Banner Header', footerBanner: 'Banner Footer', sidebarBanner: 'Banner Sidebar', contentBanner: 'Banner Konten',
    popunderLabel: 'Popunder', adsteraAds: 'Iklan Adstera', analyticsVerification: 'Analitik & Verifikasi',
    hiStatScript: 'Skrip HiStat', googleSearchConsole: 'Google Search Console',
    saveAllSettings: 'Simpan Semua Pengaturan', reset: 'Atur Ulang',
    actions: 'Aksi', title: 'Judul', noLogsYet: 'Belum ada log', details: 'Detail', ip: 'IP', time: 'Waktu',
    cancel: 'Batal', update: 'Perbarui', create: 'Buat', coverImageUrl: 'URL Gambar Sampul', excerpt: 'Ringkasan', contentHtml: 'Konten (HTML)',
    date: 'Tanggal', deleted: 'Dihapus',
  },
  'ja-JP': {
    home: 'ホーム', movies: '映画', tvShows: 'テレビ番組', genres: 'ジャンル', articles: '記事', calendar: 'カレンダー', pages: 'ページ',
    signIn: 'ログイン', signUp: '登録', signOut: 'ログアウト', email: 'メール', password: 'パスワード', name: '名前',
    createAccount: 'アカウント作成', alreadyHaveAccount: 'すでにアカウントをお持ちですか？', dontHaveAccount: 'アカウントをお持ちでないですか？',
    playTrailer: '予告編を再生', favorite: 'お気に入り', favorited: 'お気に入り済み', watchlist: 'ウォッチリスト', inWatchlist: 'ウォッチリストに追加済み',
    saved: '保存済み', like: 'いいね', liked: 'いいね済み', share: '共有', synopsis: 'あらすじ', synopsisNotAvailable: 'あlaすじは利用できません。',
    director: '監督', writers: '脚本', language: '言語', budget: '予算', revenue: '興行収入',
    watchOn: '視聴する', backdropGallery: 'バックドロップギャラリー', similarMovies: '類似映画', similar: '類似',
    recommendations: 'おすすめ', partOf: '一部',
    createdBy: '制作', episodeRuntime: 'エピソード時間', type: 'タイプ', episodes: 'エピソード',
    backToShow: '番組に戻る', seasonNotFound: 'シーズンが見つかりません', episode: 'エピソード', watch: '視聴',
    releaseCalendar: 'リリースカレンダー', upcomingReleases: '今後の映画・テレビ番組のリリース',
    thisWeek: '今週', nextWeek: '来週', twoWeeks: '2週間', threeWeeks: '3週間', oneMonth: '1ヶ月',
    moviesCount: '映画', tvShowsCount: 'テレビ番組', failedToLoad: 'リリースカレンダーの読み込みに失敗', backToHome: 'ホームに戻る',
    noReleasesThisWeek: '今週のリリースはありません', today: '本日',
    watchNow: '今すぐ視聴',
    searchMoviesTvShows: '映画・テレビ番組を検索...', searchResults: '検索結果', noResultsFound: '結果が見つかりません',
    movie: '映画', tv: 'テレビ', loading: '読み込み中...', error: 'エラー', notFound: '見つかりません', goHome: 'ホームへ',
    pleaseLogin: 'ログインしてください', removedFromFavorites: 'お気に入りから削除', addedToFavorites: 'お気に入りに追加',
    removedFromWatchlist: 'ウォッチリストから削除', addedToWatchlist: 'ウォッチリストに追加', linkCopied: 'リンクをコピーしました',
    browse: '閲覧', account: 'アカウント', legal: '法的情報', favorites: 'お気に入り', watchHistory: '視聴履歴',
    termsOfService: '利用規約', privacyPolicy: 'プライバシーポリシー', allRightsReserved: '全著作権所有。',
    poweredBy: 'TMDB API提供', releaseCalendarFooter: 'リリースカレンダー',
    settings: '設定', backToSite: 'サイトに戻る', dashboard: 'ダッシュボード', adsAndScripts: '広告＆スクリプト', activityLogs: 'アクティビティログ',
    popularMovies: '人気映画', recentUsers: '最近のユーザー', noDataAvailable: 'データなし', noUsersYet: 'ユーザーなし',
    newArticle: '新規記事', editArticle: '記事を編集', category: 'カテゴリ', status: 'ステータス',
    published: '公開中', draft: '下書き', noArticlesYet: '記事なし', author: '著者',
    newPage: '新規ページ', editPage: 'ページを編集', slug: 'スラッグ', metaDescription: 'メタ説明', noPagesYet: 'ページなし',
    user: 'ユーザー', role: '役割', joined: '参加日', noUsers: 'ユーザーなし',
    siteName: 'サイト名', siteDescription: 'サイト説明', enableComments: 'コメントを有効化', enableRatings: '評価を有効化',
    saveSettings: '設定を保存', saving: '保存中...',
    headerBanner: 'ヘッダーバナー', footerBanner: 'フッターバナー', sidebarBanner: 'サイドバーバナー', contentBanner: 'コンテンツバナー',
    popunderLabel: 'ポップアンダー', adsteraAds: 'Adstera広告', analyticsVerification: '分析＆検証',
    hiStatScript: 'HiStatスクリプト', googleSearchConsole: 'Google Search Console',
    saveAllSettings: 'すべて保存', reset: 'リセット',
    actions: '操作', title: 'タイトル', noLogsYet: 'ログなし', details: '詳細', ip: 'IP', time: '時間',
    cancel: 'キャンセル', update: '更新', create: '作成', coverImageUrl: '画像URL', excerpt: '抜粋', contentHtml: 'コンテンツ（HTML）',
    date: '日付', deleted: '削除済み',
  },
  'ko-KR': {
    home: '홈', movies: '영화', tvShows: 'TV 프로그램', genres: '장르', articles: '기사', calendar: '캘린더', pages: '페이지',
    signIn: '로그인', signUp: '회원가입', signOut: '로그아웃', email: '이메일', password: '비밀번호', name: '이름',
    createAccount: '계정 만들기', alreadyHaveAccount: '이미 계정이 있으신가요?', dontHaveAccount: '계정이 없으신가요?',
    playTrailer: '예고편 재생', favorite: '즐겨찾기', favorited: '즐겨찾기 추가됨', watchlist: '관심 목록', inWatchlist: '관심 목록에 추가됨',
    saved: '저장됨', like: '좋아요', liked: '좋아요 함', share: '공유', synopsis: '줄거리', synopsisNotAvailable: '줄거리를 사용할 수 없습니다.',
    director: '감독', writers: '각본', language: '언어', budget: '예산', revenue: '수익',
    watchOn: '시청하기', backdropGallery: '배경 갤러리', similarMovies: '유사한 영화', similar: '유사',
    recommendations: '추천', partOf: '일부',
    createdBy: '제작', episodeRuntime: '에피소드 시간', type: '유형', episodes: '에피소드',
    backToShow: '프로그램으로 돌아가기', seasonNotFound: '시즌을 찾을 수 없습니다', episode: '에피소ード', watch: '시청',
    releaseCalendar: '출시 캘린더', upcomingReleases: '다가오는 영화 및 TV 프로그램 출시',
    thisWeek: '이번 주', nextWeek: '다음 주', twoWeeks: '2주', threeWeeks: '3주', oneMonth: '1개월',
    moviesCount: '영화', tvShowsCount: 'TV 프로그램', failedToLoad: '출시 캘린더를 불러오지 못했습니다', backToHome: '홈으로 돌아가기',
    noReleasesThisWeek: '이번 주 출시작 없음', today: '오늘',
    watchNow: '지금 시청',
    searchMoviesTvShows: '영화, TV 프로그램 검색...', searchResults: '검색 결과', noResultsFound: '결과를 찾을 수 없습니다',
    movie: '영화', tv: 'TV', loading: '로딩 중...', error: '오류', notFound: '찾을 수 없음', goHome: '홈으로',
    pleaseLogin: '로그인해 주세요', removedFromFavorites: '즐겨찾기에서 제거', addedToFavorites: '즐겨찾기에 추가',
    removedFromWatchlist: '관심 목록에서 제거', addedToWatchlist: '관심 목록에 추가', linkCopied: '링크가 복사되었습니다',
    browse: '둘러보기', account: '계정', legal: '법적 정보', favorites: '즐겨찾기', watchHistory: '시청 기록',
    termsOfService: '이용약관', privacyPolicy: '개인정보 처리방침', allRightsReserved: '모든 권리 보유.',
    poweredBy: 'TMDB API 제공', releaseCalendarFooter: '출시 캘린더',
    settings: '설정', backToSite: '사이트로 돌아가기', dashboard: '대시보드', adsAndScripts: '광고 & 스크립트', activityLogs: '활동 로그',
    popularMovies: '인기 영화', recentUsers: '최근 사용자', noDataAvailable: '데이터 없음', noUsersYet: '사용자 없음',
    newArticle: '새 기사', editArticle: '기사 편집', category: '카테고리', status: '상태',
    published: '게시됨', draft: '임시저장', noArticlesYet: '기사 없음', author: '작성자',
    newPage: '새 페이지', editPage: '페이지 편집', slug: '슬러그', metaDescription: '메타 설명', noPagesYet: '페이지 없음',
    user: '사용자', role: '역할', joined: '가입일', noUsers: '사용자 없음',
    siteName: '사이트 이름', siteDescription: '사이트 설명', enableComments: '댓글 활성화', enableRatings: '평점 활성화',
    saveSettings: '설정 저장', saving: '저장 중...',
    headerBanner: '헤더 배너', footerBanner: '푸터 배너', sidebarBanner: '사이드바 배너', contentBanner: '콘텐츠 배너',
    popunderLabel: '팝언더', adsteraAds: 'Adstera 광고', analyticsVerification: '분석 & 인증',
    hiStatScript: 'HiStat 스크립트', googleSearchConsole: 'Google Search Console',
    saveAllSettings: '모두 저장', reset: '초기화',
    actions: '작업', title: '제목', noLogsYet: '로그 없음', details: '상세', ip: 'IP', time: '시간',
    cancel: '취소', update: '수정', create: '생성', coverImageUrl: '커버 이미지 URL', excerpt: '요약', contentHtml: '콘텐츠 (HTML)',
    date: '날짜', deleted: '삭제됨',
  },
  'zh-CN': {
    home: '首页', movies: '电影', tvShows: '电视剧', genres: '类型', articles: '文章', calendar: '日历', pages: '页面',
    signIn: '登录', signUp: '注册', signOut: '退出', email: '邮箱', password: '密码', name: '姓名',
    createAccount: '创建账户', alreadyHaveAccount: '已有账户？', dontHaveAccount: '没有账户？',
    playTrailer: '播放预告片', favorite: '收藏', favorited: '已收藏', watchlist: '观看列表', inWatchlist: '已在观看列表',
    saved: '已保存', like: '喜欢', liked: '已喜欢', share: '分享', synopsis: '简介', synopsisNotAvailable: '暂无简介。',
    director: '导演', writers: '编剧', language: '语言', budget: '预算', revenue: '票房',
    watchOn: '观看平台', backdropGallery: '背景图库', similarMovies: '相似电影', similar: '相似',
    recommendations: '推荐', partOf: '属于',
    createdBy: '创作者', episodeRuntime: '单集时长', type: '类型', episodes: '集',
    backToShow: '返回节目', seasonNotFound: '未找到该季', episode: '集', watch: '观看',
    releaseCalendar: '上映日历', upcomingReleases: '即将上映的电影和电视剧',
    thisWeek: '本周', nextWeek: '下周', twoWeeks: '2周', threeWeeks: '3周', oneMonth: '1个月',
    moviesCount: '电影', tvShowsCount: '电视剧', failedToLoad: '加载上映日历失败', backToHome: '返回首页',
    noReleasesThisWeek: '本周无上映作品', today: '今天',
    watchNow: '立即观看',
    searchMoviesTvShows: '搜索电影、电视剧...', searchResults: '搜索结果', noResultsFound: '未找到结果',
    movie: '电影', tv: '电视剧', loading: '加载中...', error: '错误', notFound: '未找到', goHome: '返回首页',
    pleaseLogin: '请先登录', removedFromFavorites: '已从收藏中移除', addedToFavorites: '已添加到收藏',
    removedFromWatchlist: '已从观看列表中移除', addedToWatchlist: '已添加到观看列表', linkCopied: '链接已复制',
    browse: '浏览', account: '账户', legal: '法律信息', favorites: '收藏', watchHistory: '观看历史',
    termsOfService: '服务条款', privacyPolicy: '隐私政策', allRightsReserved: '版权所有。',
    poweredBy: '由 TMDB API 提供支持', releaseCalendarFooter: '上映日历',
    settings: '设置', backToSite: '返回网站', dashboard: '仪表板', adsAndScripts: '广告与脚本', activityLogs: '活动日志',
    popularMovies: '热门电影', recentUsers: '最近用户', noDataAvailable: '暂无数据', noUsersYet: '暂无用户',
    newArticle: '新建文章', editArticle: '编辑文章', category: '分类', status: '状态',
    published: '已发布', draft: '草稿', noArticlesYet: '暂无文章', author: '作者',
    newPage: '新建页面', editPage: '编辑页面', slug: 'Slug', metaDescription: '元描述', noPagesYet: '暂无页面',
    user: '用户', role: '角色', joined: '注册时间', noUsers: '暂无用户',
    siteName: '网站名称', siteDescription: '网站描述', enableComments: '启用评论', enableRatings: '启用评分',
    saveSettings: '保存设置', saving: '保存中...',
    headerBanner: '页头横幅', footerBanner: '页脚横幅', sidebarBanner: '侧边栏横幅', contentBanner: '内容横幅',
    popunderLabel: '弹窗广告', adsteraAds: 'Adstera 广告', analyticsVerification: '分析与验证',
    hiStatScript: 'HiStat 脚本', googleSearchConsole: 'Google Search Console',
    saveAllSettings: '保存所有设置', reset: '重置',
    actions: '操作', title: '标题', noLogsYet: '暂无日志', details: '详情', ip: 'IP', time: '时间',
    cancel: '取消', update: '更新', create: '创建', coverImageUrl: '封面图片 URL', excerpt: '摘要', contentHtml: '内容 (HTML)',
    date: '日期', deleted: '已删除',
  },
  'es-ES': {
    home: 'Inicio', movies: 'Películas', tvShows: 'Series', genres: 'Géneros', articles: 'Artículos', calendar: 'Calendario', pages: 'Páginas',
    signIn: 'Iniciar sesión', signUp: 'Registrarse', signOut: 'Cerrar sesión', email: 'Correo', password: 'Contraseña', name: 'Nombre',
    createAccount: 'Crear cuenta', alreadyHaveAccount: '¿Ya tienes una cuenta?', dontHaveAccount: '¿No tienes cuenta?',
    playTrailer: 'Reproducir tráiler', favorite: 'Favorito', favorited: 'En favoritos', watchlist: 'Lista de ver', inWatchlist: 'En la lista',
    saved: 'Guardado', like: 'Me gusta', liked: 'Gustado', share: 'Compartir', synopsis: 'Sinopsis', synopsisNotAvailable: 'Sinopsis no disponible.',
    director: 'Director', writers: 'Guionistas', language: 'Idioma', budget: 'Presupuesto', revenue: 'Ingresos',
    watchOn: 'Ver en', backdropGallery: 'Galería de fondos', similarMovies: 'Películas similares', similar: 'Similares',
    recommendations: 'Recomendaciones', partOf: 'Parte de',
    createdBy: 'Creado por', episodeRuntime: 'Duración del episodio', type: 'Tipo', episodes: 'Episodios',
    backToShow: 'Volver a la serie', seasonNotFound: 'Temporada no encontrada', episode: 'Episodio', watch: 'Ver',
    releaseCalendar: 'Calendario de estrenos', upcomingReleases: 'Próximos estrenos de películas y series',
    thisWeek: 'Esta semana', nextWeek: 'Próxima semana', twoWeeks: '2 semanas', threeWeeks: '3 semanas', oneMonth: '1 mes',
    moviesCount: 'Películas', tvShowsCount: 'Series', failedToLoad: 'Error al cargar el calendario', backToHome: 'Volver al inicio',
    noReleasesThisWeek: 'Sin estrenos esta semana', today: 'HOY',
    watchNow: 'Ver ahora',
    searchMoviesTvShows: 'Buscar películas, series...', searchResults: 'Resultados', noResultsFound: 'Sin resultados',
    movie: 'Película', tv: 'Serie', loading: 'Cargando...', error: 'Error', notFound: 'No encontrado', goHome: 'Ir al inicio',
    pleaseLogin: 'Inicia sesión primero', removedFromFavorites: 'Eliminado de favoritos', addedToFavorites: 'Añadido a favoritos',
    removedFromWatchlist: 'Eliminado de la lista', addedToWatchlist: 'Añadido a la lista', linkCopied: 'Enlace copiado',
    browse: 'Explorar', account: 'Cuenta', legal: 'Legal', favorites: 'Favoritos', watchHistory: 'Historial',
    termsOfService: 'Términos de servicio', privacyPolicy: 'Política de privacidad', allRightsReserved: 'Todos los derechos reservados.',
    poweredBy: 'Con TMDB API', releaseCalendarFooter: 'Calendario de estrenos',
    settings: 'Configuración', backToSite: 'Volver al sitio', dashboard: 'Panel', adsAndScripts: 'Anuncios y Scripts', activityLogs: 'Registro de actividad',
    popularMovies: 'Películas populares', recentUsers: 'Usuarios recientes', noDataAvailable: 'Sin datos', noUsersYet: 'Sin usuarios',
    newArticle: 'Nuevo artículo', editArticle: 'Editar artículo', category: 'Categoría', status: 'Estado',
    published: 'Publicado', draft: 'Borrador', noArticlesYet: 'Sin artículos', author: 'Autor',
    newPage: 'Nueva página', editPage: 'Editar página', slug: 'Slug', metaDescription: 'Descripción meta', noPagesYet: 'Sin páginas',
    user: 'Usuario', role: 'Rol', joined: 'Registro', noUsers: 'Sin usuarios',
    siteName: 'Nombre del sitio', siteDescription: 'Descripción del sitio', enableComments: 'Habilitar comentarios', enableRatings: 'Habilitar calificaciones',
    saveSettings: 'Guardar ajustes', saving: 'Guardando...',
    headerBanner: 'Banner superior', footerBanner: 'Banner inferior', sidebarBanner: 'Banner lateral', contentBanner: 'Banner de contenido',
    popunderLabel: 'Popunder', adsteraAds: 'Anuncios Adstera', analyticsVerification: 'Analítica y verificación',
    hiStatScript: 'Script HiStat', googleSearchConsole: 'Google Search Console',
    saveAllSettings: 'Guardar todo', reset: 'Restablecer',
    actions: 'Acciones', title: 'Título', noLogsYet: 'Sin registros', details: 'Detalles', ip: 'IP', time: 'Hora',
    cancel: 'Cancelar', update: 'Actualizar', create: 'Crear', coverImageUrl: 'URL de imagen', excerpt: 'Extracto', contentHtml: 'Contenido (HTML)',
    date: 'Fecha', deleted: 'Eliminado',
  },
  'fr-FR': {
    home: 'Accueil', movies: 'Films', tvShows: 'Séries', genres: 'Genres', articles: 'Articles', calendar: 'Calendrier', pages: 'Pages',
    signIn: 'Connexion', signUp: "S'inscrire", signOut: 'Déconnexion', email: 'E-mail', password: 'Mot de passe', name: 'Nom',
    createAccount: 'Créer un compte', alreadyHaveAccount: 'Déjà un compte ?', dontHaveAccount: "Pas encore de compte ?",
    playTrailer: 'Lire la bande-annonce', favorite: 'Favori', favorited: 'En favoris', watchlist: 'Liste de lecture', inWatchlist: 'Dans la liste',
    saved: 'Enregistré', like: "J'aime", liked: 'Aimé', share: 'Partager', synopsis: 'Synopsis', synopsisNotAvailable: 'Synopsis non disponible.',
    director: 'Réalisateur', writers: 'Scénaristes', language: 'Langue', budget: 'Budget', revenue: 'Revenus',
    watchOn: 'Regarder sur', backdropGallery: "Galerie d'arrière-plans", similarMovies: 'Films similaires', similar: 'Similaires',
    recommendations: 'Recommandations', partOf: 'Fait partie de',
    createdBy: 'Créé par', episodeRuntime: 'Durée épisode', type: 'Type', episodes: 'Épisodes',
    backToShow: "Retour à la série", seasonNotFound: 'Saison introuvable', episode: 'Épisode', watch: 'Regarder',
    releaseCalendar: 'Calendrier de sortie', upcomingReleases: 'Prochaines sorties de films et séries',
    thisWeek: 'Cette semaine', nextWeek: 'Semaine prochaine', twoWeeks: '2 semaines', threeWeeks: '3 semaines', oneMonth: '1 mois',
    moviesCount: 'Films', tvShowsCount: 'Séries', failedToLoad: 'Échec du chargement', backToHome: "Retour à l'accueil",
    noReleasesThisWeek: 'Pas de sortie cette semaine', today: "AUJOURD'HUI",
    watchNow: 'Regarder maintenant',
    searchMoviesTvShows: 'Rechercher films, séries...', searchResults: 'Résultats', noResultsFound: 'Aucun résultat',
    movie: 'Film', tv: 'Série', loading: 'Chargement...', error: 'Erreur', notFound: 'Introuvable', goHome: "Retour à l'accueil",
    pleaseLogin: 'Veuillez vous connecter', removedFromFavorites: 'Retiré des favoris', addedToFavorites: 'Ajouté aux favoris',
    removedFromWatchlist: 'Retiré de la liste', addedToWatchlist: 'Ajouté à la liste', linkCopied: 'Lien copié',
    browse: 'Parcourir', account: 'Compte', legal: 'Mentions légales', favorites: 'Favoris', watchHistory: 'Historique',
    termsOfService: "Conditions d'utilisation", privacyPolicy: 'Politique de confidentialité', allRightsReserved: 'Tous droits réservés.',
    poweredBy: 'Propulsé par TMDB API', releaseCalendarFooter: 'Calendrier de sortie',
    settings: 'Paramètres', backToSite: 'Retour au site', dashboard: 'Tableau de bord', adsAndScripts: 'Publicités & Scripts', activityLogs: "Journal d'activité",
    popularMovies: 'Films populaires', recentUsers: 'Utilisateurs récents', noDataAvailable: 'Aucune donnée', noUsersYet: 'Aucun utilisateur',
    newArticle: 'Nouvel article', editArticle: 'Modifier article', category: 'Catégorie', status: 'Statut',
    published: 'Publié', draft: 'Brouillon', noArticlesYet: 'Aucun article', author: 'Auteur',
    newPage: 'Nouvelle page', editPage: 'Modifier page', slug: 'Slug', metaDescription: 'Description meta', noPagesYet: 'Aucune page',
    user: 'Utilisateur', role: 'Rôle', joined: 'Inscrit', noUsers: 'Aucun utilisateur',
    siteName: 'Nom du site', siteDescription: 'Description du site', enableComments: 'Activer les commentaires', enableRatings: 'Activer les notes',
    saveSettings: 'Enregistrer', saving: 'Enregistrement...',
    headerBanner: 'Bannière en-tête', footerBanner: 'Bannière pied de page', sidebarBanner: 'Bannière latérale', contentBanner: 'Bannière contenu',
    popunderLabel: 'Popunder', adsteraAds: 'Publicités Adstera', analyticsVerification: 'Analytique & Vérification',
    hiStatScript: 'Script HiStat', googleSearchConsole: 'Google Search Console',
    saveAllSettings: 'Tout enregistrer', reset: 'Réinitialiser',
    actions: 'Actions', title: 'Titre', noLogsYet: 'Aucun journal', details: 'Détails', ip: 'IP', time: 'Heure',
    cancel: 'Annuler', update: 'Mettre à jour', create: 'Créer', coverImageUrl: "URL de l'image", excerpt: 'Extrait', contentHtml: 'Contenu (HTML)',
    date: 'Date', deleted: 'Supprimé',
  },
  'de-DE': {
    home: 'Startseite', movies: 'Filme', tvShows: 'Serien', genres: 'Genres', articles: 'Artikel', calendar: 'Kalender', pages: 'Seiten',
    signIn: 'Anmelden', signUp: 'Registrieren', signOut: 'Abmelden', email: 'E-Mail', password: 'Passwort', name: 'Name',
    createAccount: 'Konto erstellen', alreadyHaveAccount: 'Bereits ein Konto?', dontHaveAccount: 'Noch kein Konto?',
    playTrailer: 'Trailer abspielen', favorite: 'Favorit', favorited: 'Als Favorit markiert', watchlist: 'Merkliste', inWatchlist: 'In der Merkliste',
    saved: 'Gespeichert', like: 'Gefällt mir', liked: 'Gemerkt', share: 'Teilen', synopsis: 'Handlung', synopsisNotAvailable: 'Keine Handlung verfügbar.',
    director: 'Regisseur', writers: 'Drehbuchautoren', language: 'Sprache', budget: 'Budget', revenue: 'Einnahmen',
    watchOn: 'Ansehen auf', backdropGallery: 'Hintergrundgalerie', similarMovies: 'Ähnliche Filme', similar: 'Ähnlich',
    recommendations: 'Empfehlungen', partOf: 'Teil von',
    createdBy: 'Erstellt von', episodeRuntime: 'Episodendauer', type: 'Typ', episodes: 'Episoden',
    backToShow: 'Zurück zur Serie', seasonNotFound: 'Staffel nicht gefunden', episode: 'Episode', watch: 'Ansehen',
    releaseCalendar: 'Veröffentlichungskalender', upcomingReleases: 'Kommende Film- und Serienveröffentlichungen',
    thisWeek: 'Diese Woche', nextWeek: 'Nächste Woche', twoWeeks: '2 Wochen', threeWeeks: '3 Wochen', oneMonth: '1 Monat',
    moviesCount: 'Filme', tvShowsCount: 'Serien', failedToLoad: 'Laden fehlgeschlagen', backToHome: 'Zurück zur Startseite',
    noReleasesThisWeek: 'Keine Veröffentlichungen diese Woche', today: 'HEUTE',
    watchNow: 'Jetzt ansehen',
    searchMoviesTvShows: 'Filme, Serien suchen...', searchResults: 'Suchergebnisse', noResultsFound: 'Keine Ergebnisse',
    movie: 'Film', tv: 'Serie', loading: 'Laden...', error: 'Fehler', notFound: 'Nicht gefunden', goHome: 'Zur Startseite',
    pleaseLogin: 'Bitte anmelden', removedFromFavorites: 'Aus Favoriten entfernt', addedToFavorites: 'Zu Favoriten hinzugefügt',
    removedFromWatchlist: 'Aus Merkliste entfernt', addedToWatchlist: 'Zur Merkliste hinzugefügt', linkCopied: 'Link kopiert',
    browse: 'Durchsuchen', account: 'Konto', legal: 'Rechtliches', favorites: 'Favoriten', watchHistory: 'Verlauf',
    termsOfService: 'Nutzungsbedingungen', privacyPolicy: 'Datenschutzrichtlinie', allRightsReserved: 'Alle Rechte vorbehalten.',
    poweredBy: 'Mit TMDB API', releaseCalendarFooter: 'Veröffentlichungskalender',
    settings: 'Einstellungen', backToSite: 'Zurück zur Seite', dashboard: 'Dashboard', adsAndScripts: 'Werbung & Skripte', activityLogs: 'Aktivitätsprotokoll',
    popularMovies: 'Beliebte Filme', recentUsers: 'Neueste Benutzer', noDataAvailable: 'Keine Daten', noUsersYet: 'Noch keine Benutzer',
    newArticle: 'Neuer Artikel', editArticle: 'Artikel bearbeiten', category: 'Kategorie', status: 'Status',
    published: 'Veröffentlicht', draft: 'Entwurf', noArticlesYet: 'Noch keine Artikel', author: 'Autor',
    newPage: 'Neue Seite', editPage: 'Seite bearbeiten', slug: 'Slug', metaDescription: 'Meta-Beschreibung', noPagesYet: 'Noch keine Seiten',
    user: 'Benutzer', role: 'Rolle', joined: 'Beigetreten', noUsers: 'Keine Benutzer',
    siteName: 'Seitenname', siteDescription: 'Seitenbeschreibung', enableComments: 'Kommentare aktivieren', enableRatings: 'Bewertungen aktivieren',
    saveSettings: 'Speichern', saving: 'Speichern...',
    headerBanner: 'Header-Banner', footerBanner: 'Footer-Banner', sidebarBanner: 'Sidebar-Banner', contentBanner: 'Inhalts-Banner',
    popunderLabel: 'Popunder', adsteraAds: 'Adstera-Werbung', analyticsVerification: 'Analytik & Verifizierung',
    hiStatScript: 'HiStat-Skript', googleSearchConsole: 'Google Search Console',
    saveAllSettings: 'Alles speichern', reset: 'Zurücksetzen',
    actions: 'Aktionen', title: 'Titel', noLogsYet: 'Keine Protokolle', details: 'Details', ip: 'IP', time: 'Zeit',
    cancel: 'Abbrechen', update: 'Aktualisieren', create: 'Erstellen', coverImageUrl: 'Bild-URL', excerpt: 'Auszug', contentHtml: 'Inhalt (HTML)',
    date: 'Datum', deleted: 'Gelöscht',
  },
  'pt-BR': {
    home: 'Início', movies: 'Filmes', tvShows: 'Séries', genres: 'Gêneros', articles: 'Artigos', calendar: 'Calendário', pages: 'Páginas',
    signIn: 'Entrar', signUp: 'Cadastrar', signOut: 'Sair', email: 'E-mail', password: 'Senha', name: 'Nome',
    createAccount: 'Criar conta', alreadyHaveAccount: 'Já tem conta?', dontHaveAccount: 'Não tem conta?',
    playTrailer: 'Reproduzir trailer', favorite: 'Favorito', favorited: 'Favoritado', watchlist: 'Lista de assistir', inWatchlist: 'Na lista',
    saved: 'Salvo', like: 'Curtir', liked: 'Curtido', share: 'Compartilhar', synopsis: 'Sinopse', synopsisNotAvailable: 'Sinopse não disponível.',
    director: 'Diretor', writers: 'Roteiristas', language: 'Idioma', budget: 'Orçamento', revenue: 'Receita',
    watchOn: 'Assistir em', backdropGallery: 'Galeria de fundos', similarMovies: 'Filmes similares', similar: 'Similares',
    recommendations: 'Recomendações', partOf: 'Parte de',
    createdBy: 'Criado por', episodeRuntime: 'Duração do episódio', type: 'Tipo', episodes: 'Episódios',
    backToShow: 'Voltar à série', seasonNotFound: 'Temporada não encontrada', episode: 'Episódio', watch: 'Assistir',
    releaseCalendar: 'Calendário de lançamentos', upcomingReleases: 'Próximos lançamentos de filmes e séries',
    thisWeek: 'Esta semana', nextWeek: 'Próxima semana', twoWeeks: '2 semanas', threeWeeks: '3 semanas', oneMonth: '1 mês',
    moviesCount: 'Filmes', tvShowsCount: 'Séries', failedToLoad: 'Falha ao carregar', backToHome: 'Voltar ao início',
    noReleasesThisWeek: 'Sem lançamentos esta semana', today: 'HOJE',
    watchNow: 'Assistir agora',
    searchMoviesTvShows: 'Buscar filmes, séries...', searchResults: 'Resultados', noResultsFound: 'Nenhum resultado',
    movie: 'Filme', tv: 'Série', loading: 'Carregando...', error: 'Erro', notFound: 'Não encontrado', goHome: 'Ir ao início',
    pleaseLogin: 'Faça login primeiro', removedFromFavorites: 'Removido dos favoritos', addedToFavorites: 'Adicionado aos favoritos',
    removedFromWatchlist: 'Removido da lista', addedToWatchlist: 'Adicionado à lista', linkCopied: 'Link copiado',
    browse: 'Explorar', account: 'Conta', legal: 'Legal', favorites: 'Favoritos', watchHistory: 'Histórico',
    termsOfService: 'Termos de uso', privacyPolicy: 'Política de privacidade', allRightsReserved: 'Todos os direitos reservados.',
    poweredBy: 'Feito com TMDB API', releaseCalendarFooter: 'Calendário de lançamentos',
    settings: 'Configurações', backToSite: 'Voltar ao site', dashboard: 'Painel', adsAndScripts: 'Anúncios & Scripts', activityLogs: 'Registro de atividade',
    popularMovies: 'Filmes populares', recentUsers: 'Usuários recentes', noDataAvailable: 'Sem dados', noUsersYet: 'Sem usuários',
    newArticle: 'Novo artigo', editArticle: 'Editar artigo', category: 'Categoria', status: 'Status',
    published: 'Publicado', draft: 'Rascunho', noArticlesYet: 'Sem artigos', author: 'Autor',
    newPage: 'Nova página', editPage: 'Editar página', slug: 'Slug', metaDescription: 'Descrição meta', noPagesYet: 'Sem páginas',
    user: 'Usuário', role: 'Função', joined: 'Inscrito', noUsers: 'Sem usuários',
    siteName: 'Nome do site', siteDescription: 'Descrição do site', enableComments: 'Ativar comentários', enableRatings: 'Ativar avaliações',
    saveSettings: 'Salvar', saving: 'Salvando...',
    headerBanner: 'Banner superior', footerBanner: 'Banner rodapé', sidebarBanner: 'Banner lateral', contentBanner: 'Banner conteúdo',
    popunderLabel: 'Popunder', adsteraAds: 'Anúncios Adstera', analyticsVerification: 'Analítica & Verificação',
    hiStatScript: 'Script HiStat', googleSearchConsole: 'Google Search Console',
    saveAllSettings: 'Salvar tudo', reset: 'Redefinir',
    actions: 'Ações', title: 'Título', noLogsYet: 'Sem registros', details: 'Detalhes', ip: 'IP', time: 'Hora',
    cancel: 'Cancelar', update: 'Atualizar', create: 'Criar', coverImageUrl: 'URL da imagem', excerpt: 'Trecho', contentHtml: 'Conteúdo (HTML)',
    date: 'Data', deleted: 'Excluído',
  },
  'ru-RU': {
    home: 'Главная', movies: 'Фильмы', tvShows: 'Сериалы', genres: 'Жанры', articles: 'Статьи', calendar: 'Календарь', pages: 'Страницы',
    signIn: 'Войти', signUp: 'Регистрация', signOut: 'Выйти', email: 'Эл. почта', password: 'Пароль', name: 'Имя',
    createAccount: 'Создать аккаунт', alreadyHaveAccount: 'Уже есть аккаунт?', dontHaveAccount: 'Нет аккаунта?',
    playTrailer: 'Воспроизвести трейлер', favorite: 'Избранное', favorited: 'В избранном', watchlist: 'Список просмотра', inWatchlist: 'В списке',
    saved: 'Сохранено', like: 'Нравится', liked: 'Понравилось', share: 'Поделиться', synopsis: 'Сюжет', synopsisNotAvailable: 'Сюжет недоступен.',
    director: 'Режиссёр', writers: 'Сценаристы', language: 'Язык', budget: 'Бюджет', revenue: 'Сборы',
    watchOn: 'Смотреть на', backdropGallery: 'Галерея фонов', similarMovies: 'Похожие фильмы', similar: 'Похожие',
    recommendations: 'Рекомендации', partOf: 'Часть',
    createdBy: 'Создатель', episodeRuntime: 'Хронометраж', type: 'Тип', episodes: 'Эпизоды',
    backToShow: 'Назад к сериалу', seasonNotFound: 'Сезон не найден', episode: 'Эпизод', watch: 'Смотреть',
    releaseCalendar: 'Календарь релизов', upcomingReleases: 'Предстоящие релизы фильмов и сериалов',
    thisWeek: 'На этой неделе', nextWeek: 'На следующей неделе', twoWeeks: '2 недели', threeWeeks: '3 недели', oneMonth: '1 месяц',
    moviesCount: 'Фильмы', tvShowsCount: 'Сериалы', failedToLoad: 'Ошибка загрузки', backToHome: 'На главную',
    noReleasesThisWeek: 'Нет релизов на этой неделе', today: 'СЕГОДНЯ',
    watchNow: 'Смотреть сейчас',
    searchMoviesTvShows: 'Поиск фильмов, сериалов...', searchResults: 'Результаты', noResultsFound: 'Ничего не найдено',
    movie: 'Фильм', tv: 'Сериал', loading: 'Загрузка...', error: 'Ошибка', notFound: 'Не найдено', goHome: 'На главную',
    pleaseLogin: 'Войдите в аккаунт', removedFromFavorites: 'Удалено из избранного', addedToFavorites: 'Добавлено в избранное',
    removedFromWatchlist: 'Удалено из списка', addedToWatchlist: 'Добавлено в список', linkCopied: 'Ссылка скопирована',
    browse: 'Обзор', account: 'Аккаунт', legal: 'Правовая информация', favorites: 'Избранное', watchHistory: 'История',
    termsOfService: 'Условия использования', privacyPolicy: 'Политика конфиденциальности', allRightsReserved: 'Все права защищены.',
    poweredBy: 'На TMDB API', releaseCalendarFooter: 'Календарь релизов',
    settings: 'Настройки', backToSite: 'На сайт', dashboard: 'Панель', adsAndScripts: 'Реклама и скрипты', activityLogs: 'Журнал активности',
    popularMovies: 'Популярные фильмы', recentUsers: 'Недавние пользователи', noDataAvailable: 'Нет данных', noUsersYet: 'Нет пользователей',
    newArticle: 'Новая статья', editArticle: 'Редактировать', category: 'Категория', status: 'Статус',
    published: 'Опубликовано', draft: 'Черновик', noArticlesYet: 'Нет статей', author: 'Автор',
    newPage: 'Новая страница', editPage: 'Редактировать', slug: 'Slug', metaDescription: 'Meta-описание', noPagesYet: 'Нет страниц',
    user: 'Пользователь', role: 'Роль', joined: 'Дата регистрации', noUsers: 'Нет пользователей',
    siteName: 'Название сайта', siteDescription: 'Описание сайта', enableComments: 'Включить комментарии', enableRatings: 'Включить оценки',
    saveSettings: 'Сохранить', saving: 'Сохранение...',
    headerBanner: 'Верхний баннер', footerBanner: 'Нижний баннер', sidebarBanner: 'Боковой баннер', contentBanner: 'Баннер контента',
    popunderLabel: 'Popunder', adsteraAds: 'Реклама Adstera', analyticsVerification: 'Аналитика и верификация',
    hiStatScript: 'Скрипт HiStat', googleSearchConsole: 'Google Search Console',
    saveAllSettings: 'Сохранить всё', reset: 'Сбросить',
    actions: 'Действия', title: 'Заголовок', noLogsYet: 'Нет журналов', details: 'Детали', ip: 'IP', time: 'Время',
    cancel: 'Отмена', update: 'Обновить', create: 'Создать', coverImageUrl: 'URL изображения', excerpt: 'Выдержка', contentHtml: 'Контент (HTML)',
    date: 'Дата', deleted: 'Удалено',
  },
  'th-TH': {
    home: 'หน้าแรก', movies: 'ภาพยนตร์', tvShows: 'รายการทีวี', genres: 'แนว', articles: 'บทความ', calendar: 'ปฏิทิน', pages: 'หน้า',
    signIn: 'เข้าสู่ระบบ', signUp: 'สมัครสมาชิก', signOut: 'ออกจากระบบ', email: 'อีเมล', password: 'รหัสผ่าน', name: 'ชื่อ',
    createAccount: 'สร้างบัญชี', alreadyHaveAccount: 'มีบัญชีแล้ว?', dontHaveAccount: 'ยังไม่มีบัญชี?',
    playTrailer: 'เล่นตัวอย่าง', favorite: 'รายการโปรด', favorited: 'เพิ่มในรายการโปรดแล้ว', watchlist: 'รายการที่ต้องดู', inWatchlist: 'อยู่ในรายการ',
    saved: 'บันทึกแล้ว', like: 'ถูกใจ', liked: 'ถูกใจแล้ว', share: 'แชร์', synopsis: 'เรื่องย่อ', synopsisNotAvailable: 'ไม่มีเรื่องย่อ',
    director: 'ผู้กำกับ', writers: 'ผู้เขียน', language: 'ภาษา', budget: 'งบประมาณ', revenue: 'รายได้',
    watchOn: 'ดูได้ที่', backdropGallery: 'แกลเลอรีภาพพื้นหลัง', similarMovies: 'ภาพยนตร์ที่คล้ายกัน', similar: 'คล้ายกัน',
    recommendations: 'แนะนำ', partOf: 'เป็นส่วนหนึ่งของ',
    createdBy: 'สร้างโดย', episodeRuntime: 'ความยาวตอน', type: 'ประเภท', episodes: 'ตอน',
    backToShow: 'กลับไปที่รายการ', seasonNotFound: 'ไม่พบซีซั่น', episode: 'ตอน', watch: 'ดู',
    releaseCalendar: 'ปฏิทินวันฉาย', upcomingReleases: 'ภาพยนตร์และรายการทีวีที่กำลังจะเข้าฉาย',
    thisWeek: 'สัปดาห์นี้', nextWeek: 'สัปดาห์หน้า', twoWeeks: '2 สัปดาห์', threeWeeks: '3 สัปดาห์', oneMonth: '1 เดือน',
    moviesCount: 'ภาพยนตร์', tvShowsCount: 'รายการทีวี', failedToLoad: 'โหลดปฏิทินไม่สำเร็จ', backToHome: 'กลับหน้าแรก',
    noReleasesThisWeek: 'ไม่มีวันฉายสัปดาห์นี้', today: 'วันนี้',
    watchNow: 'ดูเลย',
    searchMoviesTvShows: 'ค้นหาภาพยนตร์ รายการทีวี...', searchResults: 'ผลการค้นหา', noResultsFound: 'ไม่พบผลลัพธ์',
    movie: 'ภาพยนตร์', tv: 'ทีวี', loading: 'กำลังโหลด...', error: 'ข้อผิดพลาด', notFound: 'ไม่พบ', goHome: 'ไปหน้าแรก',
    pleaseLogin: 'กรุณาเข้าสู่ระบบ', removedFromFavorites: 'ลบออกจากรายการโปรด', addedToFavorites: 'เพิ่มในรายการโปรด',
    removedFromWatchlist: 'ลบออกจากรายการ', addedToWatchlist: 'เพิ่มในรายการ', linkCopied: 'คัดลอกลิงก์แล้ว',
    browse: 'เรียกดู', account: 'บัญชี', legal: 'ข้อกฎหมาย', favorites: 'รายการโปรด', watchHistory: 'ประวัติ',
    termsOfService: 'ข้อกำหนดการใช้งาน', privacyPolicy: 'นโยบายความเป็นส่วนตัว', allRightsReserved: 'สงวนลิขสิทธิ์ทุกประการ',
    poweredBy: 'ขับเคลื่อนโดย TMDB API', releaseCalendarFooter: 'ปฏิทินวันฉาย',
    settings: 'การตั้งค่า', backToSite: 'กลับไปยังเว็บไซต์', dashboard: 'แดชบอร์ด', adsAndScripts: 'โฆษณาและสคริปต์', activityLogs: 'บันทึกกิจกรรม',
    popularMovies: 'ภาพยนตร์ยอดนิยม', recentUsers: 'ผู้ใช้ล่าสุด', noDataAvailable: 'ไม่มีข้อมูล', noUsersYet: 'ยังไม่มีผู้ใช้',
    newArticle: 'บทความใหม่', editArticle: 'แก้ไขบทความ', category: 'หมวดหมู่', status: 'สถานะ',
    published: 'เผยแพร่', draft: 'ฉบับร่าง', noArticlesYet: 'ยังไม่มีบทความ', author: 'ผู้เขียน',
    newPage: 'หน้าใหม่', editPage: 'แก้ไขหน้า', slug: 'Slug', metaDescription: 'คำอธิบายเมตา', noPagesYet: 'ยังไม่มีหน้า',
    user: 'ผู้ใช้', role: 'บทบาท', joined: 'วันที่เข้าร่วม', noUsers: 'ไม่มีผู้ใช้',
    siteName: 'ชื่อเว็บไซต์', siteDescription: 'คำอธิบายเว็บไซต์', enableComments: 'เปิดใช้งานความคิดเห็น', enableRatings: 'เปิดใช้งานการให้คะแนน',
    saveSettings: 'บันทึกการตั้งค่า', saving: 'กำลังบันทึก...',
    headerBanner: 'แบนเนอร์ส่วนหัว', footerBanner: 'แบนเนอร์ส่วนท้าย', sidebarBanner: 'แบนเนอร์แถบด้านข้าง', contentBanner: 'แบนเนอร์เนื้อหา',
    popunderLabel: 'Popunder', adsteraAds: 'โฆษณา Adstera', analyticsVerification: 'การวิเคราะห์และการยืนยัน',
    hiStatScript: 'สคริปต์ HiStat', googleSearchConsole: 'Google Search Console',
    saveAllSettings: 'บันทึกทั้งหมด', reset: 'รีเซ็ต',
    actions: 'การกระทำ', title: 'ชื่อ', noLogsYet: 'ยังไม่มีบันทึก', details: 'รายละเอียด', ip: 'IP', time: 'เวลา',
    cancel: 'ยกเลิก', update: 'อัปเดต', create: 'สร้าง', coverImageUrl: 'URL รูปภาพ', excerpt: 'บทสรุป', contentHtml: 'เนื้อหา (HTML)',
    date: 'วันที่', deleted: 'ลบแล้ว',
  },
  'vi-VN': {
    home: 'Trang chủ', movies: 'Phim', tvShows: 'Phim truyền hình', genres: 'Thể loại', articles: 'Bài viết', calendar: 'Lịch', pages: 'Trang',
    signIn: 'Đăng nhập', signUp: 'Đăng ký', signOut: 'Đăng xuất', email: 'Email', password: 'Mật khẩu', name: 'Tên',
    createAccount: 'Tạo tài khoản', alreadyHaveAccount: 'Đã có tài khoản?', dontHaveAccount: 'Chưa có tài khoản?',
    playTrailer: 'Phát trailer', favorite: 'Yêu thích', favorited: 'Đã yêu thích', watchlist: 'Danh sách xem', inWatchlist: 'Trong danh sách',
    saved: 'Đã lưu', like: 'Thích', liked: 'Đã thích', share: 'Chia sẻ', synopsis: 'Tóm tắt', synopsisNotAvailable: 'Không có tóm tắt.',
    director: 'Đạo diễn', writers: 'Biên kịch', language: 'Ngôn ngữ', budget: 'Ngân sách', revenue: 'Doanh thu',
    watchOn: 'Xem trên', backdropGallery: 'Thư viện ảnh nền', similarMovies: 'Phim tương tự', similar: 'Tương tự',
    recommendations: 'Đề xuất', partOf: 'Là một phần của',
    createdBy: 'Sáng tạo bởi', episodeRuntime: 'Thời lượng tập', type: 'Loại', episodes: 'Tập',
    backToShow: 'Quay lại phim', seasonNotFound: 'Không tìm thấy mùa', episode: 'Tập', watch: 'Xem',
    releaseCalendar: 'Lịch phát hành', upcomingReleases: 'Phim và phim truyền hình sắp phát hành',
    thisWeek: 'Tuần này', nextWeek: 'Tuần sau', twoWeeks: '2 tuần', threeWeeks: '3 tuần', oneMonth: '1 tháng',
    moviesCount: 'Phim', tvShowsCount: 'Phim truyền hình', failedToLoad: 'Tải lịch thất bại', backToHome: 'Về trang chủ',
    noReleasesThisWeek: 'Không có phát hành tuần này', today: 'HÔM NAY',
    watchNow: 'Xem ngay',
    searchMoviesTvShows: 'Tìm phim, phim truyền hình...', searchResults: 'Kết quả', noResultsFound: 'Không tìm thấy',
    movie: 'Phim', tv: 'Truyền hình', loading: 'Đang tải...', error: 'Lỗi', notFound: 'Không tìm thấy', goHome: 'Về trang chủ',
    pleaseLogin: 'Vui lòng đăng nhập', removedFromFavorites: 'Đã xóa khỏi yêu thích', addedToFavorites: 'Đã thêm vào yêu thích',
    removedFromWatchlist: 'Đã xóa khỏi danh sách', addedToWatchlist: 'Đã thêm vào danh sách', linkCopied: 'Đã sao chép liên kết',
    browse: 'Duyệt', account: 'Tài khoản', legal: 'Pháp lý', favorites: 'Yêu thích', watchHistory: 'Lịch sử',
    termsOfService: 'Điều khoản dịch vụ', privacyPolicy: 'Chính sách bảo mật', allRightsReserved: 'Bảo lưu mọi quyền.',
    poweredBy: 'Cung cấp bởi TMDB API', releaseCalendarFooter: 'Lịch phát hành',
    settings: 'Cài đặt', backToSite: 'Về trang web', dashboard: 'Bảng điều khiển', adsAndScripts: 'Quảng cáo & Mã nguồn', activityLogs: 'Nhật ký hoạt động',
    popularMovies: 'Phim phổ biến', recentUsers: 'Người dùng gần đây', noDataAvailable: 'Không có dữ liệu', noUsersYet: 'Chưa có người dùng',
    newArticle: 'Bài viết mới', editArticle: 'Sửa bài viết', category: 'Danh mục', status: 'Trạng thái',
    published: 'Đã xuất bản', draft: 'Bản nháp', noArticlesYet: 'Chưa có bài viết', author: 'Tác giả',
    newPage: 'Trang mới', editPage: 'Sửa trang', slug: 'Slug', metaDescription: 'Mô tả meta', noPagesYet: 'Chưa có trang',
    user: 'Người dùng', role: 'Vai trò', joined: 'Ngày tham gia', noUsers: 'Chưa có người dùng',
    siteName: 'Tên trang web', siteDescription: 'Mô tả trang web', enableComments: 'Bật bình luận', enableRatings: 'Bật đánh giá',
    saveSettings: 'Lưu cài đặt', saving: 'Đang lưu...',
    headerBanner: 'Biểu ngữ đầu trang', footerBanner: 'Biểu ngữ cuối trang', sidebarBanner: 'Biểu ngữ thanh bên', contentBanner: 'Biểu ngữ nội dung',
    popunderLabel: 'Popunder', adsteraAds: 'Quảng cáo Adstera', analyticsVerification: 'Phân tích & Xác minh',
    hiStatScript: 'Mã HiStat', googleSearchConsole: 'Google Search Console',
    saveAllSettings: 'Lưu tất cả', reset: 'Đặt lại',
    actions: 'Thao tác', title: 'Tiêu đề', noLogsYet: 'Chưa có nhật ký', details: 'Chi tiết', ip: 'IP', time: 'Thời gian',
    cancel: 'Hủy', update: 'Cập nhật', create: 'Tạo', coverImageUrl: 'URL ảnh bìa', excerpt: 'Trích đoạn', contentHtml: 'Nội dung (HTML)',
    date: 'Ngày', deleted: 'Đã xóa',
  },
  'tr-TR': {
    home: 'Ana Sayfa', movies: 'Filmler', tvShows: 'Diziler', genres: 'Türler', articles: 'Makaleler', calendar: 'Takvim', pages: 'Sayfalar',
    signIn: 'Giriş Yap', signUp: 'Kayıt Ol', signOut: 'Çıkış Yap', email: 'E-posta', password: 'Şifre', name: 'İsim',
    createAccount: 'Hesap Oluştur', alreadyHaveAccount: 'Zaten hesabınız var mı?', dontHaveAccount: 'Hesabınız yok mu?',
    playTrailer: 'Fragmanı Oynat', favorite: 'Favori', favorited: 'Favorilere eklendi', watchlist: 'İzleme Listesi', inWatchlist: 'Listede',
    saved: 'Kaydedildi', like: 'Beğen', liked: 'Beğenildi', share: 'Paylaş', synopsis: 'Özet', synopsisNotAvailable: 'Özet mevcut değil.',
    director: 'Yönetmen', writers: 'Senaristler', language: 'Dil', budget: 'Bütçe', revenue: 'Gişe',
    watchOn: 'İzle', backdropGallery: 'Arka Plan Galerisi', similarMovies: 'Benzer Filmler', similar: 'Benzer',
    recommendations: 'Öneriler', partOf: 'Parçası',
    createdBy: 'Yaratan', episodeRuntime: 'Bölüm Süresi', type: 'Tür', episodes: 'Bölümler',
    backToShow: 'Diziye Dön', seasonNotFound: 'Sezon bulunamadı', episode: 'Bölüm', watch: 'İzle',
    releaseCalendar: 'Yayın Takvimi', upcomingReleases: 'Yaklaşan film ve dizi yayınları',
    thisWeek: 'Bu Hafta', nextWeek: 'Gelecek Hafta', twoWeeks: '2 Hafta', threeWeeks: '3 Hafta', oneMonth: '1 Ay',
    moviesCount: 'Filmler', tvShowsCount: 'Diziler', failedToLoad: 'Yükleme başarısız', backToHome: 'Ana Sayfaya Dön',
    noReleasesThisWeek: 'Bu hafta yayın yok', today: 'BUGÜN',
    watchNow: 'Şimdi İzle',
    searchMoviesTvShows: 'Film, dizi ara...', searchResults: 'Sonuçlar', noResultsFound: 'Sonuç bulunamadı',
    movie: 'Film', tv: 'Dizi', loading: 'Yükleniyor...', error: 'Hata', notFound: 'Bulunamadı', goHome: 'Ana Sayfa',
    pleaseLogin: 'Lütfen giriş yapın', removedFromFavorites: 'Favorilerden kaldırıldı', addedToFavorites: 'Favorilere eklendi',
    removedFromWatchlist: 'Listeden kaldırıldı', addedToWatchlist: 'Listeye eklendi', linkCopied: 'Bağlantı kopyalandı',
    browse: 'Keşfet', account: 'Hesap', legal: 'Yasal', favorites: 'Favoriler', watchHistory: 'Geçmiş',
    termsOfService: 'Kullanım Şartları', privacyPolicy: 'Gizlilik Politikası', allRightsReserved: 'Tüm hakları saklıdır.',
    poweredBy: 'TMDB API ile', releaseCalendarFooter: 'Yayın Takvimi',
    settings: 'Ayarlar', backToSite: 'Siteye Dön', dashboard: 'Kontrol Paneli', adsAndScripts: 'Reklamlar ve Komut Dosyaları', activityLogs: 'Aktivite Günlüğü',
    popularMovies: 'Popüler Filmler', recentUsers: 'Son Kullanıcılar', noDataAvailable: 'Veri yok', noUsersYet: 'Henüz kullanıcı yok',
    newArticle: 'Yeni Makale', editArticle: 'Makaleyi Düzenle', category: 'Kategori', status: 'Durum',
    published: 'Yayınlandı', draft: 'Taslak', noArticlesYet: 'Henüz makale yok', author: 'Yazar',
    newPage: 'Yeni Sayfa', editPage: 'Sayfayı Düzenle', slug: 'Slug', metaDescription: 'Meta Açıklama', noPagesYet: 'Henüz sayfa yok',
    user: 'Kullanıcı', role: 'Rol', joined: 'Katılım', noUsers: 'Henüz kullanıcı yok',
    siteName: 'Site Adı', siteDescription: 'Site Açıklaması', enableComments: 'Yorumları Etkinleştir', enableRatings: 'Puanlamayı Etkinleştir',
    saveSettings: 'Kaydet', saving: 'Kaydediliyor...',
    headerBanner: 'Üst Banner', footerBanner: 'Alt Banner', sidebarBanner: 'Kenar Çubuğu Bannerı', contentBanner: 'İçerik Bannerı',
    popunderLabel: 'Popunder', adsteraAds: 'Adstera Reklamları', analyticsVerification: 'Analitik ve Doğrulama',
    hiStatScript: 'HiStat Komut Dosyası', googleSearchConsole: 'Google Search Console',
    saveAllSettings: 'Tümünü Kaydet', reset: 'Sıfırla',
    actions: 'İşlemler', title: 'Başlık', noLogsYet: 'Henüz günlük yok', details: 'Detaylar', ip: 'IP', time: 'Saat',
    cancel: 'İptal', update: 'Güncelle', create: 'Oluştur', coverImageUrl: 'Kapak Resmi URL', excerpt: 'Özet', contentHtml: 'İçerik (HTML)',
    date: 'Tarih', deleted: 'Silindi',
  },
};

export type TranslationKey = keyof TranslationKeys;

export function getTranslation(langCode: string, key: TranslationKey): string {
  const lang = translations[langCode];
  if (lang && key in lang) return lang[key];
  // Fallback to English
  return translations['en-US'][key] || key;
}

export default translations;
